import * as React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import IntakeVisitScreen from '@app/screens/intake/visit'
import { useDocumentTitle } from '@app/utils/use-document-title'

import type { RouteComponentProps} from 'react-router-dom';

interface ILayout {
  routes?: IRoute[]
  children?: React.ReactNode
}

export interface IRoute {
  label?: string
  component:
    | React.ComponentType<RouteComponentProps<unknown>>
    | React.ComponentType<unknown>
  exact?: boolean
  path: string
  title: string
  isAsync?: boolean
}

const RouteWithTitleUpdates = ({
  component: Component,
  title,
  ...rest
}: IRoute) => {
  useDocumentTitle(title)

  function routeWithTitle(routeProps: RouteComponentProps) {
    return <Component {...rest} {...routeProps} />
  }

  return <Route render={routeWithTitle} />
}

const IntakeLayout: React.FunctionComponent<ILayout> = ({
  routes,
  children,
}) => {
  const AppRoutes = () => (
    <Switch>
      {routes.map(({ path, exact, component, title, isAsync }, idx) => (
        <RouteWithTitleUpdates
          path={path}
          exact={exact}
          component={component}
          key={idx}
          title={title}
          isAsync={isAsync}
        />
      ))}
      <Route path="/intake/visit/:id" component={IntakeVisitScreen} />
      <Route path="*">
        <Redirect to="/404" />
      </Route>
    </Switch>
  )

  return (
    <div>
      <AppRoutes />
      {children}
    </div>
  )
}

export { IntakeLayout }
